<script lang="ts">
    import Flyout from "./components/flyout/Flyout.svelte";
</script>

<Flyout></Flyout>
